
/**
 * Hartley Video - LED Vision Analytics Utility
 * Provides a safe wrapper around gtag for event tracking.
 */

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

export const trackEvent = (eventName: string, params: Record<string, any> = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
  
  // Debug logging for local development
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  if (isLocal) {
    console.log(`[Analytics] ${eventName}`, params);
  }
};

export const trackPageView = (title: string) => {
  trackEvent('page_view', {
    page_title: title,
    page_location: window.location.href,
    page_path: window.location.pathname
  });
};
